export class ExtensionsDaysRequest {
  applicationId: string;
  daysRemainingAtStatus: number;
  numberOfExtensionDays: string;
}
